import React, { forwardRef, MouseEventHandler, useEffect, useImperativeHandle, useState } from "react";
import Loader from "../Loader/Loader";
import { CustomButton } from "./Button.styled";
import { ButtonVariant } from "./Button.constants";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	children: React.ReactNode;
	style?: React.CSSProperties;
	controlSize?: "m" | "sm" | "xsm";
	isLoading?: boolean;
	variant?: ButtonVariant;
	onClick?: MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
	type?: "button" | "submit" | "reset";
}

export interface ButtonRef {
	setLoading: (loading: boolean) => void;
}

export const Button = forwardRef<ButtonRef, ButtonProps>(
	(
		{
			children,
			style,
			controlSize = "m",
			isLoading = false,
			variant = ButtonVariant.Primary,
			onClick,
			disabled,
			type = "button",
			...rest
		},
		ref,
	) => {
		const [state, setState] = useState({
			isLoading: isLoading,
		});

		useEffect(() => {
			setState({ isLoading });
		}, [isLoading]);

		const loaderColor = variant === ButtonVariant.Primary || variant === ButtonVariant.Secondary ? "white" : "black";

		useImperativeHandle(ref, () => ({
			setLoading: (isLoading: boolean) => setState((x) => ({ ...x, isLoading })),
		}));

		return (
			<CustomButton
				style={style}
				onClick={(e) => {
					if (state.isLoading) return;
					onClick?.(e);
				}}
				disabled={disabled}
				type={type}
				$variant={variant}
				$controlSize={controlSize}
				{...rest}>
				{state.isLoading ? <Loader controlSize={controlSize} color={loaderColor} /> : children}
			</CustomButton>
		);
	},
);

export default Button;
